export default __webpack_public_path__ + "static/ShortTerm-new-c7347e16bd292e0a8e90969aca81af52.jpg";